module.exports = __webpack_public_path__ + "img/autoshow-slide-03.0dc1048d.png";